import dialogType from '../../../../../../../display/dialogs/dialogType'

import Method from '../../../../../../../net/Method'

const preventions =
{
    title : 'Préventions' ,
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des préventions dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        method      : Method.PATCH,
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Préventions' ,
        type        : dialogType.THESAURUS_CHECKER
    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default preventions ;